<!--Lista que contiene todos los niveles de un plan(afiliación)-->
<template>
    <v-container fluid class="py-0">
        <v-row justify="center" v-if="colors.length === tiers.length">
            <v-col cols="12" sm="6" md="4" xl="3" v-for="(tier, index) in tiers" :key="index" class="pb-3 pt-lg-0">
                <pricing-item :tier="tier" :color="colors[index]" v-bind:first="(index===0)?true:false"></pricing-item>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import pricingItem from './pricingItem'
import { lightenDarkenColor } from '@/helpers/helpers'
export default {
    props:{
        tiers:{ type: Array, required: true }
    },
    components:{
        pricingItem
    },
    data(){
        return {
            first: true,
            colors:[],
        }
    },
    async mounted(){
        this.colorsReady = false
        let total = 0;
        let step = 1 / this.tiers.length;
        
        for(let i=0; i<this.tiers.length; i++){
            let back = await lightenDarkenColor('#09203F', (0.5-total));
            this.colors.unshift({ background: back, button: '#fcc401'})
            total+=step;
        }
    }, 
}
</script>